import React, { useImperativeHandle } from "react";
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// eslint-disable-next-line
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import '../../../styles/main.css';
import CxDialog from "../../cx/CxDialog";
import CxInput from "../../cx/CxInput";
import { useTranslation } from '../../hx/useTranslation';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStylesLocal = makeStyles({
  frame: {
    backgroundColor: 'var(--ibs_color_white)',
    color: 'var(--ibs_color_black)',
    padding: '0px 0 0px 4px',
    height: props => props.height || '300px',
    width: 'var(--ibs_control_width_lg)',
  },

  radio: {
    height: '10px',
  },

  radioLabel: {
    padding: '4px 0 4px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: '0px 0px 0px 0px',
    cursor: 'default',
    textAlign: 'left',
    //color: 'var(--ibs_color_gray)',
    fontSize: '11px',
    "&.MuiFormControlLabel-root": {
      width: props => {
        if (props.width) {
          return props.width;
        } else {
          return '100%'
        }
      },
    },
  },

  formControlLabelRoot: {
    "&.MuiFormControlLabel-root": {
      alignItems: 'flex-start', // ESTO ES CLAVE: alinea el radio y el Typography al inicio
      width: props => {
        if (props.width) {
          return props.width;
        } else {
          return '100%'
        }
      },
    },
  },

  radioGroupContainer: {
    marginTop: '10px',
    maxHeight: '260px', // Limita la altura máxima a 150px
    overflowY: 'auto',   // Agrega una barra de desplazamiento vertical si el contenido excede la altura
    padding: '0 8px 0 8px', // Opcional: añade un poco de padding a la derecha para que el scroll no "toque" los labels
    background: 'var(--ibs_color_gray_light)',
  },

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%', // Asegura que ocupe todo el espacio disponible
    position: 'absolute', // Permite superponerse al contenido
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)', // Fondo semi-transparente
    zIndex: 1000, // Asegura que esté por encima de otros elementos
  },

});

const MxPsRxAutoCimavetDlg = props => {
  const [{ trans }] = useTranslation();
  const classesL = useStylesLocal(props);
  const { onResult, } = props;
  const [open, setOpen] = React.useState(false);
  const [medicamentos, setMedicamentos] = React.useState([]);
  const [presentaciones, setPresentaciones] = React.useState([]);
  const [myValueMedicamento, setMyValueMedicamento] = React.useState('');
  const [myValuePresentacion, setMyValuePresentacion] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [showPres, setShowPres] = React.useState(false);
  const rf_search_medicamentos = React.useRef(null);
  const rf_radio_group_medicamentos = React.useRef(null);
  const rf_radio_group_presentaciones = React.useRef(null);
  
  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const handleChangeMedicamento = (event) => {
    let nregistro = event.target.value;
    FxLog.infox('MxPsRxAutoCimavetDlg.handleChangeMedicamento', '...nregistro:', nregistro);
    setMyValueMedicamento(nregistro);
    setShowPres(true);
    doSearchPresentaciones(nregistro);
  };

  const handleChangePresentacion = (event) => {
    let cn = event.target.value.split('|')[0];
    let txDrugStrength = event.target.value.split('|')[1]; // es la presentación
    let record = {};
    record['cn'] = cn;
    Promise.all([FxFetch.doJsonX(`pss/rx_auto/cimavet/medicamento_unico`, record)]).then((result) => {
      if (result[0]) {
        let rv = result[0][0];
        FxLog.infox('MxPsRxAutoCimavetDlg.handleChangePresentacion', '...rv:', rv);
        const drugData = {
          txTypeDispensing: rv.dispensacion?.nombre==='Sujeto a prescripción veterinaria' ? 'D' : 'N',
          txTypeTreatment: 'T', /* debe ponerlo el vett */
          txCode: cn,
          txDrugStrength: txDrugStrength, 
          txNature: Boolean(rv.antibiotico) ? 'antibiótico' : '',
          txPharmaceuticalForm: rv.forma?.nombre,
          txRouteAdministration: rv.viasAdministracion[0].nombre,
          txActiveIngredient: rv.pactivos,
          txDosageInformation: '', /* esto está en la ficha técnica */
          nuDrugPerc: '100.0',
          txDurationTreatment: '', /* debe ponerlo el vett */
          txWithdrawalMilk: getWithdrawalTime(rv, 'leche', 'Bovino'),
          txWithdrawalMeat: getWithdrawalTime(rv, 'carne', 'Bovino'),
          txWithdrawalEggs: getWithdrawalTime(rv, 'huevo', 'Bovino'),
          txDirections: '',
          url: rv.docs[0]?.url,
        };        
        onResult(drugData);
        setOpen(false);

      }
      setLoading(false);
    });

  };

  const getWithdrawalTime = (medicationData, tissueType, speciesName) => {
    if (!medicationData || !medicationData.tiemposEspera) {
      return ""; 
    }

    const normalizedTissueType = tissueType.toLowerCase();
    const normalizedSpeciesName = speciesName.toLowerCase();

    let foundTime = "";

    medicationData.tiemposEspera.forEach(time => {
      const { especie, tejido, cantidad, unidadTiempo, observaciones } = time;
      
      // Uso de Optional Chaining para evitar el error de lectura sobre null
      const currentTissueName = tejido?.nombre?.toLowerCase() || "";
      const currentSpeciesName = especie?.nombre?.toLowerCase() || "";

      if (currentTissueName.includes(normalizedTissueType) && currentSpeciesName === normalizedSpeciesName) {
        if (observaciones) {
          foundTime = observaciones;
        } else if (cantidad && unidadTiempo?.nombre) {
          foundTime = `${cantidad} ${unidadTiempo.nombre}`;
        }
      }
    });

    return foundTime;
  };

  useImperativeHandle(props.xref, () => {
    return {
      getType, setOpenDlg,
    };
  });
  const getType = () => { return 'MxPsRxAutoCimavetDlg' };

  const setOpenDlg = (open) => {
    setMyValueMedicamento(null);
    setMyValuePresentacion(null);
    setLoading(false);
    setShowPres(false);
    setMedicamentos([]);
    setOpen(open);
  }

  const doSearchMedicamentos = () => {
    let record = {};
    record['search'] = rf_search_medicamentos.current.getVal();
    setLoading(true);
    Promise.all([FxFetch.doJsonX(`pss/rx_auto/cimavet/medicamentos`, record)]).then((result) => {
      if (result[0]) {
        FxLog.infox('MxPsRxAutoCimavetDlg.doSearchMedicamentos', '...result[0]:', result[0]);
        // Aquí es donde cargas los datos del backend
        setMedicamentos(result[0]); // result[0] debería ser tu array de objetos { id, type }
      } else {
        setMedicamentos([]); // Si no hay resultados, vacía la lista
      }
      setLoading(false);
    });
  }

  const doSearchPresentaciones = (nregistro) => {
    let record = {};
    record['nregistro'] = nregistro;
    setLoading(true);
    Promise.all([FxFetch.doJsonX(`pss/rx_auto/cimavet/presentaciones`, record)]).then((result) => {
      if (result[0]) {
        FxLog.infox('MxPsRxAutoCimavetDlg.doSearchPresentaciones', '...result[0]:', result[0]);
        // Aquí es donde cargas los datos del backend
        setPresentaciones(result[0]); // result[0] debería ser tu array de objetos { id, type }
      } else {
        setPresentaciones([]); // Si no hay resultados, vacía la lista
      }
      setLoading(false);
    });
  }

  return (
    <div>
      <CxDialog
        title={props.title}
        open={open}
        onClose={() => setOpen(false)}
        height='400px'
        >
        {loading && ( // Muestra el indicador de carga si loading es true
          <div className={classesL.loadingContainer}>
            <CircularProgress />
          </div>
        )}

        <div className={classesL.frame} style={{ display: showPres ? 'none' : 'block', }}>
          <CxInput xref={rf_search_medicamentos} 
            label={trans('field.search')} 
            width="var(--ibs_control_width_lg)" 
            onSearch={() => doSearchMedicamentos()}
            onEnter={() => doSearchMedicamentos()}
          />

          <div className={classesL.radioGroupContainer}>
            <RadioGroup ref={rf_radio_group_medicamentos} value={myValueMedicamento} onChange={handleChangeMedicamento} >
              {medicamentos && medicamentos.map((option) => (
                option.nregistro && 
                  <FormControlLabel value={option.nregistro} key={option.nombre} classes={{ root: classesL.formControlLabelRoot }}
                    control={
                      <Radio className={classesL.radio} size='small' />
                    } 
                    label={
                      <Typography className={classesL.radioLabel}>{option.nombre}</Typography>
                    } 
                  />
              ))}
            </RadioGroup>
          </div>

        </div>

        <div className={classesL.frame} style={{ display: showPres ? 'block' : 'none', }}>

          <div className={classesL.radioGroupContainer}>
            <RadioGroup ref={rf_radio_group_presentaciones} value={myValuePresentacion} onChange={handleChangePresentacion} >
              {presentaciones && presentaciones.map((option) => (
                option.cn && 
                  <FormControlLabel value={option.cn +'|'+ option.nombre} key={option.nombre} classes={{ root: classesL.formControlLabelRoot }}
                    control={
                      <Radio className={classesL.radio} size='small' />
                    } 
                    label={
                      <Typography className={classesL.radioLabel}>{option.nombre}</Typography>
                    } 
                  />
              ))}
            </RadioGroup>
          </div>

        </div>

      </CxDialog>
    </div>
  );
};

export default MxPsRxAutoCimavetDlg;
